import React from 'react';
import { Routes, Route, Outlet, Navigate, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import queryString from 'query-string';
import { jwtDecode } from 'jwt-decode';

import { useAppAuth } from "./hooks/useAppAuth";

import HomePage from './pages/HomePage';
import TreatmentPage from './pages/app/TreatmentPage';
import OffsetsPage from './pages/app/OffsetsPage';
import ContactsPage from './pages/app/ContactsPage';
import ReportPage from './pages/ReportPage';
import SignUp from './pages/authentication/SignUp';
import SignIn from './pages/authentication/SignIn';
import Profile from './pages/account/Profile';
import FpzReports from './pages/account/FpzReports';
import StartFpz from './pages/app/StartFpzPage';
import CompaniesPage from './pages/app/CompaniesPage';

import AppShell from './components/Layout/AppShell';
import AuthenticationShell from './components/Layout/AuthenticationShell';
import LandingShell from './components/Layout/LandingShell';
import { navItems } from "./pages/app/components/navItems";


import { APPID } from './common/constants';
import { appRegistries } from "./registries";

// TEMP
import SinglePage from './singlepage';

function RequireAuth() {
  const { isAuthed } = useAppAuth(APPID);
  const location = useLocation();
  if (!isAuthed) return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}

function AppShellLayout() {
  const { isAuthed, userState } = useAppAuth(APPID);
  const { pathname } = useLocation();
  const { app } = appRegistries;
  console.log('appRegistries', appRegistries)
  let cfg = app[pathname] || app['/app'];

  const { user } = userState;
  cfg.user = isAuthed ? {
    name: user?.user_first_name + ' ' + user?.user_last_name,
    email: user?.user_email,
    id: user?.user_id,
  } : null;


  return (
    <AppShell navItems={navItems} {...cfg}>
      <Outlet />
    </AppShell>
  );
}


function ClearFpzRoute({ children }) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch({ type: "CLEAR_FPZ" });
  }, [dispatch]);

  return children;
}


function AuthenticationShellLayout() {
  const { pathname } = useLocation();
  const { authentication } = appRegistries;
  const cfg = authentication[pathname];

  return (
    <AuthenticationShell  {...cfg}>
      <Outlet />
    </AuthenticationShell>
  );
}

function LandingShellLayout() {
  const { pathname } = useLocation();
  const { landing } = appRegistries;
  const cfg = landing[pathname];

  const { isAuthed } = useAppAuth(APPID);
  cfg.primaryCta = isAuthed ? cfg?.primaryCta?.authed : cfg?.primaryCta?.guest;
  cfg.secondaryCta = isAuthed ? cfg?.secondaryCta?.authed : cfg?.secondaryCta?.guest;
  cfg.isAuthed = isAuthed;
  console.log('LandingShellLayout ', 'path', pathname, ' cfg:', cfg);
  return (
    <LandingShell {...cfg}>
      <Outlet />
    </LandingShell>
  );
}



function App() {
  return (
    <Routes>

      <Route element={<AuthenticationShellLayout />}>
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/login" element={<SignIn />} />
      </Route>

      {/* Require authentication to access */}
      <Route element={<RequireAuth />}>
        {/* App shell layout */}
        <Route path="/app" element={<AppShellLayout />}>
          <Route path="account/profile" element={<Profile />} />
          <Route path="account/reports" element={<FpzReports />} />
          <Route path="companies" element={<CompaniesPage />} />
          <Route path="company" element={<CompaniesPage />} />
          <Route path="report" element={<ReportPage />} />
          <Route path="contacts" element={<ContactsPage />} />
          <Route path="offsets" element={<OffsetsPage />} />
          <Route path="treatment" element={<TreatmentPage />} />
          <Route path="new" element={<ClearFpzRoute><StartFpz /></ClearFpzRoute>} />
          <Route index element={<StartFpz />} />

        </Route>

        {/* No layout (no shell) */}
        <Route path="/report" element={<ReportPage />} />
        <Route path="/report/:fpzReportId" element={<ReportPage />} />
      </Route>


      <Route element={<LandingShellLayout />}>
        {/* Landing shell layout */}
        <Route path="/" element={<HomePage />} />
      </Route>

      <Route path="/single" element={<SinglePage />} />
      <Route path="/test" element={<LandingShell />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
